import { render } from "./settings-ems.vue?vue&type=template&id=5fca3915"
import script from "./settings-ems.vue?vue&type=script&lang=js"
export * from "./settings-ems.vue?vue&type=script&lang=js"

import "./settings-ems.vue?vue&type=style&index=0&id=5fca3915&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__